export default function ContactCTA() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-10 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            商务合作与爆料通道
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto leading-relaxed">
            品牌合作、广告投放、独家爆料，欢迎通过以下方式联系我们。你的每一条消息，我们都会认真对待。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d92dhu00sqa2sn3dnfeg"
              method="POST"
              encType="application/x-www-form-urlencoded"
              className="space-y-5"
            >
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  姓名
                </label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  required
                  placeholder="请输入您的姓名"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-400 transition-colors duration-200"
                />
              </div>

              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  邮箱
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  required
                  placeholder="请输入您的邮箱地址"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-400 transition-colors duration-200"
                />
              </div>

              <div>
                <label htmlFor="contact-type" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  合作类型
                </label>
                <select
                  id="contact-type"
                  name="contact_type"
                  required
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-400 transition-colors duration-200"
                >
                  <option value="">请选择合作类型</option>
                  <option value="brand">品牌广告合作</option>
                  <option value="tip">独家爆料投稿</option>
                  <option value="media">媒体资源互换</option>
                  <option value="other">其他合作</option>
                </select>
              </div>

              <div>
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  留言内容
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  rows={4}
                  maxLength={500}
                  placeholder="请详细描述您的合作需求或爆料内容（限500字）"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-400 transition-colors duration-200 resize-none"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1">限500字以内</p>
              </div>

              <div style={{ position: "absolute", left: "-9999px", opacity: 0 }} aria-hidden="true">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" />
              </div>

              <button
                type="submit"
                className="whitespace-nowrap w-full px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold cursor-pointer hover:bg-primary-600 transition-colors duration-200"
              >
                提交信息
              </button>
            </form>
          </div>

          <div className="flex flex-col justify-center gap-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-accent-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  北京市朝阳区建国路88号<br />SOHO现代城A座1208室
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-accent-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">联系电话</h4>
                <p className="text-sm text-foreground-600">+86 400-000-0000</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-accent-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                <p className="text-sm text-foreground-600">hello@cgiqwhk.cn</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-accent-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">工作时间</h4>
                <p className="text-sm text-foreground-600">周一至周日 9:00 - 24:00（全年无休）</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}